import {
  // eslint-disable-next-line no-unused-vars
  h,
  // eslint-disable-next-line no-unused-vars
  Fragment,
  Component,
  createRef,
  render,
} from 'preact';
import axios, { CancelToken } from 'axios';
import store from '../../utils/localStorageFallback';
import ResultList from './ResultList';

class ClientPlanningModule extends Component {
  state = {
    query: '',
    cat: '',
    options: [],
    entries: [],
    version: store('version'),
    initialLoad: false,
    loading: false,
  };

  constructor(props) {
    super(props);

    this.inputRef = createRef();
    this.cancelToken = () => {};
    this.runSearchQuery();
    this.loadSelectOptions();
  }

  handleInputChange = (event) => {
    this.setState(
      {
        query: event.target.value,
        loading: true,
        entries: [],
      },
      this.runSearchQuery,
    );
  };

  handleKeyDown = (event) => {
    if (event.which === 27 || event.which === 13) {
      event.preventDefault();
      this.setState(
        {
          query: event.target.value,
          loading: true,
          entries: [],
        },
        this.runSearchQuery,
      );
    }
  };

  handleSelectChange = (event) => {
    this.setState(
      {
        cat: event.target.value,
        loading: true,
        entries: [],
      },
      this.runSearchQuery,
    );
  };

  clearFilters = (e) => {
    e.preventDefault();

    const searchInput = document.getElementById('client-planning-search');
    const categorySelect = document.getElementById('client-planning-category');
    searchInput.value = '';
    categorySelect.value = '';

    this.setState(
      {
        query: '',
        cat: '',
        loading: true,
        entries: [],
      },
      this.runSearchQuery,
    );
  };

  loadSelectOptions = async () => {
    const response = await axios.get(`/wp-json/deepsea/v1/client-planning-categories`);

    if (!Array.isArray(response.data.categories) || !response.data.categories.length) {
      this.setState({
        options: false,
      });
      return;
    }

    this.setState({
      options: response.data.categories,
    });
  };

  runSearchQuery = async () => {
    const { query, cat, version } = this.state;

    try {
      this.cancelToken();

      let catFilterQuery = '';
      if (cat !== '') {
        catFilterQuery = `&cat=${cat}`;
      }

      let versionFilterQuery = '';
      if (version) {
        versionFilterQuery = `&version=${version}`;
      } else {
        versionFilterQuery = `&version=adviser`;
      }

      const searchResponse = await axios.get(
        `/wp-json/deepsea/v1/client-planning?s=${query}${catFilterQuery}${versionFilterQuery}`,
        {
          cancelToken: new CancelToken((c) => {
            this.cancelToken = c;
          }),
        },
      );

      if (!Array.isArray(searchResponse.data.posts) || !searchResponse.data.posts.length) {
        this.setState({
          entries: false,
          loading: false,
          initialLoad: false,
        });
        return;
      }

      this.setState({
        entries: searchResponse.data.posts,
        loading: false,
        initialLoad: false,
      });
    } catch (e) {
      if (!axios.isCancel(e)) {
        this.setState({
          loading: false,
          initialLoad: false,
        });
      }
    }
  };

  render() {
    const { entries, query, options, cat, loading, initialLoad } = this.state;

    return (
      <section className="section">
        <div className="section-wrapper">
          {initialLoad && (
            <div className="deepsea-loader-wrap">
              <p className="deepsea-loader deepsea-loader--white">
                <span className="deepsea-spinner">Loading...</span>
                Please wait
              </p>
            </div>
          )}
          {!initialLoad && (
            <>
              <div className="client-planning-filters">
                <form
                  className="deepsea-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <div className="input-search">
                    <label htmlFor="client-planning-search">What are you looking for?</label>
                    <input
                      ref={this.inputRef}
                      type="text"
                      name="search"
                      id="client-planning-search"
                      placeholder="Estate planning"
                      onKeyDown={this.handleKeyDown}
                      value={query}
                    />
                  </div>
                  <div className="select-filter">
                    <label htmlFor="client-planning-category">Planning category</label>
                    <select
                      className="select-css"
                      name="category"
                      id="client-planning-category"
                      onChange={this.handleSelectChange}
                    >
                      <option>All</option>
                      {options.map((option) => (
                        <option key={option.slug} value={option.slug}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {(cat !== '' || query !== '') && (
                    <div>
                      <button
                        className="clearFiltersBtn btn btn--subtle"
                        onClick={this.clearFilters}
                      >
                        Clear filters
                      </button>
                    </div>
                  )}
                </form>
              </div>
              <div className="client-planning-results">
                {entries && !loading && <ResultList entries={entries} />}
                {!entries.length && !loading && (
                  <div className="client-planning--no-results">
                    <h3>No results.</h3>
                    <p>
                      <a onClick={this.clearFilters}>Search again</a> or try removing filters.
                    </p>
                  </div>
                )}
                {loading && (
                  <p className="deepsea-loader deepsea-loader--small deepsea-loader--white">
                    <span className="deepsea-spinner">Loading...</span>
                    Please wait
                  </p>
                )}
              </div>
            </>
          )}
        </div>
      </section>
    );
  }
}

const setup = () => {
  const $ele = document.getElementById('client-planning-module');
  if ($ele) {
    render(<ClientPlanningModule />, $ele);
  }
};
setup();
